interface VesselFormData {
  vesselName: string;
  callSign: string;
  regNumber: string;
  location: string;
  flag: string;
}

interface CrewPrintRow {
  name: string;
  rank: string;
  nationality: string;
  birthDate: string;
  seamanBookNumber: string;
  seamanBookExpiry: string;
  joinDate: string;
}

export const generateCrewListPrintHtml = (
  vesselData: VesselFormData,
  crewRows: CrewPrintRow[]
): string => {
  const vName = vesselData.vesselName || '...............';
  const vCallSign = vesselData.callSign || '...............';
  const vReg = vesselData.regNumber || '...............';
  const vLocation = vesselData.location || '...............';
  const vFlag = vesselData.flag || '...............';
  const vDate = new Date().toLocaleDateString('ar-EG');

  return `<!DOCTYPE html>
<html dir="rtl">
  <head>
    <meta charset="UTF-8">
    <title>F.06.03.02 CREW LIST</title>
    <style>
      * { margin: 0; padding: 0; box-sizing: border-box; }
      body {
        font-family: 'Arial', 'Tahoma', sans-serif;
        padding: 20px;
        font-size: 12px;
        direction: rtl;
      }
      .header {
        text-align: center;
        margin-bottom: 20px;
        border: 2px solid #000;
        padding: 10px;
      }
      .header h1 { font-size: 18px; font-weight: bold; }
      .vessel-info {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 10px;
        margin-bottom: 20px;
        border: 1px solid #000;
        padding: 10px;
      }
      .vessel-info-row {
        display: flex;
        border-bottom: 1px solid #ccc;
        padding: 5px 0;
      }
      .vessel-info-row:last-child { border-bottom: none; }
      .vessel-info-label { font-weight: bold; min-width: 120px; }
      .vessel-info-value { flex: 1; }
      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
      }
      th {
        background-color: #d9d9d9;
        border: 1px solid #000;
        padding: 8px 5px;
        text-align: center;
        font-weight: bold;
        font-size: 11px;
      }
      td {
        border: 1px solid #000;
        padding: 6px 5px;
        text-align: center;
        font-size: 11px;
      }
      tr:nth-child(even) { background-color: #f9f9f9; }
      @media print {
        body { padding: 10px; }
        @page { margin: 1cm; size: landscape; }
      }
    </style>
  </head>
  <body>
    <div class="header">
      <h1>F.06.03.02&nbsp;&nbsp;&nbsp;CREW LIST</h1>
    </div>
    
    <div class="vessel-info">
      <div>
        <div class="vessel-info-row">
          <span class="vessel-info-label">اسم المركب :</span>
          <span class="vessel-info-value">${vName}</span>
        </div>
      </div>
      <div>
        <div class="vessel-info-row">
          <span class="vessel-info-label">رمز النداء :</span>
          <span class="vessel-info-value">${vCallSign}</span>
        </div>
      </div>
      <div>
        <div class="vessel-info-row">
          <span class="vessel-info-label">رقم التسجيل :</span>
          <span class="vessel-info-value">${vReg}</span>
        </div>
      </div>
      <div>
        <div class="vessel-info-row">
          <span class="vessel-info-label">الموقع :</span>
          <span class="vessel-info-value">${vLocation}</span>
        </div>
      </div>
      <div>
        <div class="vessel-info-row">
          <span class="vessel-info-label">التاريخ :</span>
          <span class="vessel-info-value">${vDate}</span>
        </div>
      </div>
      <div>
        <div class="vessel-info-row">
          <span class="vessel-info-label">العلم :</span>
          <span class="vessel-info-value">${vFlag}</span>
        </div>
      </div>
    </div>

    <table>
      <thead>
        <tr>
          <th>الاسم</th>
          <th>الوظيفة</th>
          <th>الجنسية</th>
          <th>تاريخ الميلاد</th>
          <th>رقم الجواز البحري</th>
          <th>تاريخ انتهاء الجواز البحري</th>
          <th>تاريخ التعيين</th>
        </tr>
      </thead>
      <tbody>
        ${crewRows.map(crew => `
          <tr>
            <td>${crew.name}</td>
            <td>${crew.rank}</td>
            <td>${crew.nationality}</td>
            <td>${crew.birthDate}</td>
            <td>${crew.seamanBookNumber}</td>
            <td>${crew.seamanBookExpiry}</td>
            <td>${crew.joinDate}</td>
          </tr>
        `).join('')}
        ${crewRows.length === 0 ? '<tr><td colspan="7" style="text-align: center; padding: 20px;">لا يوجد أفراد طاقم</td></tr>' : ''}
      </tbody>
    </table>

    <script>window.onload = function() { window.print(); };</script>
  </body>
</html>`;
};

export const generateCrewListWordHtml = (
  vesselData: VesselFormData,
  crewRows: CrewPrintRow[]
): string => {
  return `
    <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8">
        <title>F.06.03.02 CREW LIST</title>
        <style>
          body { font-family: 'Arial', sans-serif; direction: rtl; text-align: right; }
          .header { text-align: center; margin-bottom: 20px; border: 2px solid #000; padding: 10px; }
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #000; padding: 8px; text-align: center; }
          th { background-color: #d9d9d9; }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>F.06.03.02 CREW LIST</h1>
        </div>
        <p><strong>اسم المركب :</strong> ${vesselData.vesselName || '...'} &nbsp;&nbsp; <strong>رمز النداء :</strong> ${vesselData.callSign || '...'} &nbsp;&nbsp; <strong>رقم التسجيل :</strong> ${vesselData.regNumber || '...'}</p>
        <p><strong>الموقع :</strong> ${vesselData.location || '...'} &nbsp;&nbsp; <strong>التاريخ :</strong> ${new Date().toLocaleDateString('ar-EG')} &nbsp;&nbsp; <strong>العلم :</strong> ${vesselData.flag || '...'}</p>
        <br/>
        <table>
          <thead>
            <tr>
              <th>الاسم</th>
              <th>الوظيفة</th>
              <th>الجنسية</th>
              <th>تاريخ الميلاد</th>
              <th>رقم الجواز البحري</th>
              <th>تاريخ انتهاء الجواز البحري</th>
              <th>تاريخ التعيين</th>
            </tr>
          </thead>
          <tbody>
            ${crewRows.map(crew => `
              <tr>
                <td>${crew.name}</td>
                <td>${crew.rank}</td>
                <td>${crew.nationality}</td>
                <td>${crew.birthDate}</td>
                <td>${crew.seamanBookNumber}</td>
                <td>${crew.seamanBookExpiry}</td>
                <td>${crew.joinDate}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </body>
    </html>
  `;
};
